import {
  START_REPEATORDER_TO_ORDERPAD,
  SUCCESS_REPEATORDER_TO_ORDERPAD,
  ERROR_REPEATORDER_TO_ORDERPAD,
  START_CREATE_ORDER_PAD,
  SUCCESS_CREATE_ORDERPAD,
  ERROR_CREATE_ORDERPAD,
  START_CREATE_TODAY_ORDER_PAD,
  SUCCESS_CREATE_TODAY_ORDERPAD,
  ERROR_CREATE_TODAY_ORDERPAD,
} from "Actions/OrderPadAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  repeatorderToOrderpadAPI,
  createOrderPadAPI,
  createTodayOrderPadAPI,
} from "Api/OrderPadApis";
import { call, put, takeEvery } from "redux-saga/effects";

function* repeatorderToOrderpadWorker({ payload }) {
  try {
    const res = yield call(repeatorderToOrderpadAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_REPEATORDER_TO_ORDERPAD,
        payload: res?.data ? res.data : {},
      });
    } else {
      yield put({
        type: ERROR_REPEATORDER_TO_ORDERPAD,
        payload: res,
      });
    }
  } catch (error) { }
}

function* createOrderPadWorker({ payload }) {
  try {
    const res = yield call(createOrderPadAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_ORDERPAD,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "RX added successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_ORDERPAD,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.message,
          type: "error",
        },
      });
    }
  } catch (error) { }
}

function* createTodayOrderPadWorker({ payload }) {
  try {
    const res = yield call(createTodayOrderPadAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_TODAY_ORDERPAD,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "RX added successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_TODAY_ORDERPAD,
        payload: res,
      });
      // yield put({
      //   type: ADD_NEW_NOTIFICATION,
      //   payload: {
      //     message: res.message,
      //     type: "error",
      //   },
      // });
    }
  } catch (error) { }
}

export function* OrderPadSaga() {
  yield takeEvery(START_REPEATORDER_TO_ORDERPAD, repeatorderToOrderpadWorker);
  yield takeEvery(START_CREATE_ORDER_PAD, createOrderPadWorker);
  yield takeEvery(START_CREATE_TODAY_ORDER_PAD, createTodayOrderPadWorker);
}
